module.exports = __webpack_public_path__ + "img/banner01.ca98446f.jpg";